import React, {useEffect, useState} from "react";
import associateServices from "../../services";
import SplideContainer from "../splide-container";
import Loading from "../loading";
import StyleHelper from "../../helpers/styleHelper";
import {useTranslation} from "react-i18next";

const TableGames = () => {

    const {t} = useTranslation()
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [coloredData, setColoredData] = useState([])
    useEffect(() => {
        setColoredData(data?.map(oo => ({
            ...oo,
            color: oo.color === 'random' ? StyleHelper.getRandomColor() : oo.color
        })))
    }, [data])
    useEffect(() => {
        setLoading(true)
        associateServices.getDashboardSlideGames({
            type: 'table-games'
        }).then(handleResponse)
    }, [])

    const handleResponse = (res) => {
        setData(res?.data)
        setLoading(false)
    }


    return (
        <SplideContainer
            title={t('sidebar.table-games')}
            data={coloredData}
            loading={loading}
            icon={'table-games'}
            path={'/casino/group/table-games'}

        />
    )

}

export default TableGames
/*

 */
